import { createAsyncThunk } from '@reduxjs/toolkit';
import qs from 'qs';
import dayjs from 'dayjs';

import { config } from '@platform/constants';
import { httpService, AscResponse, reverseDateFormat } from '@ascendnow/shared';
import * as Response from '@shared/models/billing/billing.response.type';
import * as Request from '@shared/models/billing/billing.request.type';
import { setInvoices, setPaymentMethods, setPaymentPlans } from '../slices/payments.slice';
import { formatErrorMessage } from '@ascendnow/ascend-components';

export const PaymentEndpoints = {
    getPaymentPlans: config.base_url + '/payments/plans',
    getPaymentMethods: config.base_url + '/payments/customer/methods',
    getTransactions: (params) => config.base_url + `/payments/subscription/transactions?${params ? params : ''}`,
};

export const fetchPaymentMethods = createAsyncThunk(PaymentEndpoints.getPaymentMethods, async (query, { dispatch }) => {
    try {
        const response = await httpService
            .get<AscResponse<Response.IFetchPaymentMethodsResponse>>(PaymentEndpoints.getPaymentMethods)
            .then((res) => res.data.data);
        dispatch(setPaymentMethods(response));
    } catch (error) {
        console.log(
            formatErrorMessage(error, `Error fetching payment methods, query: ${PaymentEndpoints.getPaymentMethods}`),
            { type: 'error' }
        );
    }
});

export const fetchPaymentPlans = createAsyncThunk(PaymentEndpoints.getPaymentPlans, async (query, { dispatch }) => {
    try {
        const response = await httpService
            .get<AscResponse<Response.IFetchPaymentPlansResponse>>(PaymentEndpoints.getPaymentPlans)
            .then((res) => res.data.data);

        dispatch(setPaymentPlans(response));
    } catch (error) {
        console.log(formatErrorMessage(error, `Error fetching payment plans, query: ${PaymentEndpoints.getPaymentPlans}`), {
            type: 'error',
        });
    }
});

export const fetchInvoices = createAsyncThunk(
    PaymentEndpoints.getTransactions({}),
    async (params: Request.IBillingLogRequestType, { dispatch }) => {
        try {
            const from_date = reverseDateFormat(params.from);
            const to_date = reverseDateFormat(params.to);
            const queryParams = qs.stringify({
                limit: 50,
                ...(params.from ? { from_date: Date.parse(from_date) } : {}),
                ...(params.to
                    ? {
                          to_date: Date.parse(
                              from_date === to_date ? dayjs(to_date).add(1, 'day').format('YYYY-MM-DD') : to_date
                          ),
                      }
                    : {}),
                ...(params.status ? { status: params.status.toUpperCase() } : {}),
                ...(params.sortBy ? { sort_by: params.sortBy } : {}),
                ...(params.sortOrder ? { sort_order: params.sortOrder } : {}),
            });

            const res = await httpService.get<AscResponse<{ transactions: Response.ITransactionResponse }>>(
                PaymentEndpoints.getTransactions(queryParams)
            );

            dispatch(setInvoices(res.data.data.transactions));
        } catch (error) {
            console.log(formatErrorMessage(error, `Error fetching invoices, query: ${PaymentEndpoints.getTransactions}`), {
                type: 'error',
            });
        }
    }
);
